import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CartMaster } from '../model/CartMaster.model';
import { CourseMaster } from '../model/CourseMaster.model';
import { OfferMaster } from '../model/OfferMaster.model';
import { ReceiptMaster } from '../model/ReceiptMaster.model';
import { StudentMaster } from '../model/StudentMaster.model';
import { AuthService } from '../service/auth.service';
import { MainserviceService } from '../service/mainservice.service';
import {MessageService} from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-my-cart',
  templateUrl: './my-cart.component.html',
  styleUrls: ['./my-cart.component.scss']
})
export class MyCartComponent implements OnInit {
  cartMaster:CartMaster=new CartMaster()
  studentMaster:StudentMaster=new StudentMaster()
  cartMasterList:CartMaster[]=[];
  cartMasterListTemp:CartMaster[]=[];
  tempCourse:CourseMaster[]=[];
  tempCourse1:CourseMaster[]=[];
  pageSize: number = 8;
  pageNumber: number = 0;
  totalRecords:number=0;
  showbtn:boolean=true;
  recieptMaster:ReceiptMaster=new ReceiptMaster();
  offerMaster:OfferMaster=new OfferMaster();
  actualAmount:number=0;
  offeredAmount:number=0;

  courseCartTemp:CourseMaster=new CourseMaster();

  courseMasterList: CourseMaster[]=[];

  courselistTemp:CourseMaster=new CourseMaster();

  constructor(private authService:AuthService,private mainService:MainserviceService, private router:Router
    ,private messageService: MessageService,public spinnerService: NgxSpinnerService) { }

  ngOnInit() {
    this.spinnerService.show()
    this.getCartList();
    this.getCourseMasterList();
    
  
    
    
  }

  getCartList(){
    
   
    this.cartMaster.studentMaster = new StudentMaster();
    this.studentMaster=this.authService.getUserSession();
    this.cartMaster.studentMaster.studentMasterId = this.studentMaster.studentMasterId;
    
    this.mainService.getCartMasterList(this.cartMaster).subscribe(data=>{
      this.cartMasterList = data;

      this.spinnerService.hide()
      
      this.cartMasterList.forEach(course => {

       
        this.actualAmount=this.actualAmount+course.courseMaster.actualPrice;
        this.offeredAmount=this.offeredAmount+course.courseMaster.offeredPrice;

      });

     
    })

    
     
    
  
  }



  saveCart(course:CourseMaster){

  
   
  
    this.cartMaster.courseMaster=course;
    this.cartMaster.studentMaster=this.studentMaster;
   
  
  
    this.mainService.saveCartMaster(this.cartMaster).subscribe(data => {
      this.cartMaster = data;
      this.messageService.add({severity:'success', summary:'Successfully', detail:'Added to Cart'});
      this.cartMaster=new CartMaster();
      this.actualAmount=0;
      this.offeredAmount=0;
      this.getCartList();
  
  
   }, (err: HttpErrorResponse) => {
     if (err.status === 200) {
      this.messageService.add({severity:'success', summary:'Successfully', detail:'Added to Cart'});
      this.cartMaster=new CartMaster();
      this.getCartList();
       let jsonString = err.error.text;
       jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
       // this.packageServiceList = JSON.parse(jsonString);
  
     }
  
  
   })
  
  
  }



  getCourseMasterList() {

    this.courselistTemp.isMasterCourse=false;

    this.courselistTemp.pageNumber = this.courselistTemp.pageNumber
      ? this.courselistTemp.pageNumber
      : this.pageNumber;
    this.courselistTemp.pageSize = this.courselistTemp.pageSize
      ? this.courselistTemp.pageSize
      : this.pageSize;
    
    this.mainService.getCourseMasterList(this.courselistTemp).subscribe(
      (data) => {
        this.courseMasterList = data;
        this.getCourseMasterListLength();

        
        
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }


  incrementPage(){

   
    this.courselistTemp.pageNumber=this.courselistTemp.pageNumber
    this.courselistTemp.pageSize=this.courselistTemp.pageSize+8;
  
    this.getCourseMasterList();
    
    
    if(this.courselistTemp.pageSize>=this.totalRecords){
     
      this.showbtn=false;
    }
  }


  getCourseMasterListLength() {
   



    this.courselistTemp.isMasterCourse=false;

    this.mainService.getCourseMasterListLength(this.courselistTemp).subscribe(data => {
      this.totalRecords = data;
      
    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        this.courselistTemp = JSON.parse(jsonString);

      }


    })
  }

  viewCourse(courseMaster:CourseMaster){
    this.authService.setcourseMasterSession(courseMaster);
    
      this.router.navigateByUrl('/course-details');
    
  }




  deleteCart(cartMaster: CartMaster) {





    Swal.fire({
      customClass:{
        container:'logout-popup',
      },
      title: 'Are you sure you want to remove this course?',
      
     
      
  showCancelButton: true,
  confirmButtonColor: '#faa41c',
  cancelButtonColor: '#fff',
  cancelButtonText:'Cancel',
  confirmButtonText: 'Yes'
      
  
    }).then((result) => {
      if (result.dismiss != null && result.dismiss != undefined) {
        Swal.close();
      }
      else {
        
  
        let message = ' delete';

        this.cartMaster.cartMasterId=cartMaster.cartMasterId;
       
           
            this.mainService.deleteCartMaster(this.cartMaster).subscribe(
              (data) => {
                // this.studentMaster.vendorMenuOptionsList = this.vendorMenuMaster.vendorMenuOptionsList.filter(data => data !== vendorOption);
                this.actualAmount=0;
                this.offeredAmount=0;
                this.cartMaster=new CartMaster();
                
                this.getCartList();
               
               
              },
              (error) => {
                if (error instanceof HttpErrorResponse) {
                  if (error.status === 200) {
                    this.cartMaster=new CartMaster();
                    this.actualAmount=0;
                    this.offeredAmount=0;
                    this.getCartList();
                 
                  } else {
                  }
                }
              }
            );
  
  
  
  
  
   
   
  
      }
    
    
    })







  }
    

 
  




  paymentPage(){
    


    this.cartMasterList.forEach(course => {
      course.courseMaster.courseLectureMasterList = [];

        this.tempCourse.push(course.courseMaster)
        
    
  })
    
  this.authService.setcourseListSession(this.tempCourse);
    
  this.router.navigateByUrl('/payment-confirmation')
  }


 
 

}
